<template>
    <div class="web-layout bg-light">
        <carousel :activeNavbar="activeNav" :height="'auto'" :action="{
                  text:'立即注册/登录',
                  type:'login',
                  params:null}"></carousel>
        <!-- <banner :layout="banner"></banner> -->
        <b-container fluid="sm" class="web-layout-content bg-white h-100 rounded rounded-lg " :style="`top: -${0}px;min-height:360px;z-index:19;padding: 20px 0 20px 0`">
            <scrollLayout :height="40" class="mb-4 pl-3 pr-3" :title="'公告'"></scrollLayout>
            <!-- < -->
            <!-- <navpath></navpath> -->
            <b-container fluid >
                <b-container fluid class=" p-0">
                    <b-row  class="mb-4">
                        <b-col  md="6" class="">
                            <listLayout 
                            :layoutNo="`LM20230712100001`" 
                            listLayout="textNoWarp" 
                            :rowspan="4" 
                            :height="500"
                            :colsMaps="{title:'title',date:'create_time'}"
                            :banner="{img:'thn_img',type:'layout'}"
                            ></listLayout>
                        </b-col>
                        <b-col  md="6" class="">
                            <listLayout 
                            ref="listLayoutScience"
                            :layoutNo="`LM20230713110005`" 
                            listLayout="textNoWarp" 
                            :rowspan="2" 
                            :height="500"
                            :colsMaps="{title:'title',date:'create_time'}"
                            :banner="{img:'thn_img',type:'layout'}"
                            :footer="{img:footerImg,href:'login'}"
                            ></listLayout>
                        </b-col>
                    </b-row>
                    <b-row  class="mb-4">
                        <!-- <b-col  md="4" class="">
                            <listLayout 
                            :layoutNo="`LM20230713110005`" 
                            listLayout="textNoWarp" 
                            :rowspan="5" 
                            :colsMaps="{title:'title',date:'create_time'}"
                            ></listLayout>
                        </b-col> -->
                        <b-col md="6" class="">
                            <listLayout 
                            :layoutNo="`LM20230713110004`" 
                            listLayout="textNoWarp" 
                            :rowspan="5" 
                            :colsMaps="{title:'title',date:'create_time'}"
                            ></listLayout>
                        </b-col>
                        <b-col md="6" class="">
                            <listLayout 
                            :layoutNo="`LM20230712100003`" 
                            listLayout="textNoWarp" 
                            :rowspan="5" 
                            :colsMaps="{title:'title',date:'create_time'}"
                            ></listLayout>
                        </b-col>
                    </b-row>
                    <b-row class="mb-4">
                        <b-col md="4" v-for="(url,index) in banners" class="mb-2">
                            <b-img left :src="url.url" fluid alt="" @click="toPage(url)"></b-img>
                        </b-col>
                        <!-- <b-col cols="4" class="">
                            <b-img left src="https://file.moyublog.com/d/file/2021-11-23/lnesybrj3mm.jpg" fluid alt=""></b-img>
                        </b-col>
                        <b-col cols="4" class="">
                            <b-img left src="https://file.moyublog.com/d/file/2021-11-23/lnesybrj3mm.jpg" fluid alt=""></b-img>
                        </b-col> -->
                    </b-row>
                    <banner :layout="'text'" :text="{cn:'友情链接',en:'Friendly Links'}" :height="72"></banner>
                    
                </b-container>
                
            </b-container>
        </b-container>
        <b-container fluid class=" bg-lightprimary">
            <b-container>
                <div class="mb-0 p-2 d-flex justify-content-md-around flex-column flex-md-row">
                    <div class="p-1" v-for="(link,index) in links">
                        <b-link :href="link.link_url" target="_block" class="text-white w-md-25" >{{link.link_name}}</b-link>
                    </div>
                    
                    <!-- <b-link href="" class="text-white w-md-25">注册营养师</b-link>
                    <b-link href="" class="text-white w-md-25">陕西卫生健康委员会</b-link>
                    <b-link href="" class="text-white w-md-25">陕西省科学技术协会</b-link> -->
                </div>
            </b-container>
        </b-container>
        
    </div>
    
</template>
  
  <script>
  
import store from '@/store'
  import banner from '@/components/banner.vue'
  import navpath from '@/components/navpath.vue'
  import actionList from '@/components/actionList.vue'
  import tabs from '@/components/tabs.vue'
  import list from '@/components/list.vue'
  import detail from '@/components/detail.vue'
  import carousel from '@/components/carousel.vue'
  import scrollLayout from '@/components/scrollLayout.vue'
  import listLayout from '@/components/listLayout.vue'
  
import { getWebSitePcCarousel,friendLinks } from '@/api/api.js'


import login from '@/assets/index/login.png'
import b1 from '@/assets/index/6.jpg'
import b2 from '@/assets/index/7.jpg'
import b3 from '@/assets/index/8.jpg'
  export default {
    name: 'index',
    components: {
        banner ,navpath,actionList,list,tabs,detail,carousel,scrollLayout,listLayout
    },
    props: {
      msg: String
    },
    computed:{
        getListData(){
            console.log(0.12,this.$refs.listLayoutScience);
            console.log(0.121,this.$refs.listLayoutScience.listData);
            
            return this.$refs.listLayoutScience.listData
        },
        activeNav(){
            let key = store.getters.getActiveNav 
            key = key ? key.key : ''
            return key
        }
    },
    data(){
        return {
            banner:{
                height:"300",
            },
            active:'',
            footerImg:login,
            banners:[
                {url:b1,layoutNo:'LM20230831100002'},
                {url:b2,layoutNo:'LM20230713180008'},
                {url:b3,layoutNo:'LM20230713180006'}],
            links:[]
        }
    },
    created(){
    },
    mounted(){
        this.getLinks()
    },
    methods:{
        onClick(e){
            this.active = e
        },
        toPage(url){
            let no = url.layoutNo
            if(no){
                let navs = store.getters.getNavs
                let active = this.getTree(navs,'key','parent_no',no)
                let root = null
                if(active.length == 1){
                    active = active[0]
                    if(active.parent_no){
                        root = this.getTree(navs,'key','parent_no',active.parent_no)
                        if(root.length == 1){
                            root = root[0]
                        }
                    }else{
                        root = active
                    }
                }
                if(active.children && active.children.length > 0){
                    active = active.children[0]
                }
                
                store.commit('setActiveNav',root) 

                
                this.toHomePage(active,root.key)
            }
        },
        getLinks(){
            let no = this.webConfig.webNo
            let req = {
            "serviceName": "srvcms_friend_links_select",
            "colNames": [
                "*"
            ],
            "condition": [
                {
                "colName": "website_no",
                "ruleType": "eq",
                "value": no
                },
                {
                "colName": "display",
                "ruleType": "eq",
                "value": '是'
                }
            ],
            "relation_condition": {},
            "page": {
                "pageNo": 1,
                "rownumber": 999
            },
            "order": [],
            "draft": false,
            "query_source": "list_page"
            }
            friendLinks(req,'ws').then((res) => {
                // console.log('友情链接',res)
                this.links = res.data.map(item => item)
            })
        }
    }

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  .web-layout{
    .web-layout-content{
        position: relative;
    }
  }
  </style>
  